import React, {useState, useEffect} from 'react';
import { Alert, Form, FormControl, FormGroup, Button, FormLabel, Spinner, ProgressBar } from 'react-bootstrap'; 
import { useTranslation } from 'react-i18next'
import { Redirect } from 'react-router';
import Customize from './Customize'

import {closestCenter, DndContext, PointerSensor, useSensor} from '@dnd-kit/core';
import {horizontalListSortingStrategy, SortableContext, arrayMove} from '@dnd-kit/sortable';
import Attachment from './Attachment';
import SignersCategory from './SignersCategory';
import axios from 'axios';

const constants = require('./constants');

const RequestSignature = props => {
    const { t } = useTranslation();

    const [docName, setDocName] = useState("");
    const [docReferences, setdocReferences] = useState([]);
    
    const [signersCategoryIndex, setSignersCategoryIndex] = useState(1);
    const [signersCategory, setSignersCategory] = useState([{id:signersCategoryIndex, signers:[], forceOrder:false, dueDate:"", reminderDate:""}]);
    
    const [subject, setSubject] = useState("");
    const [message, setMessage] = useState("");
    const [duedate, setDuedate] = useState("");
    const [reminder, setReminder] = useState("");
    const [messagePlaceholder, setMessagePlaceholder] = useState("");
    const [redirectPath, setRedirectPath] = useState(null);
    const [fileValidState, setFileValidState] = useState('IDLE');
    const [fileCheckIcon, setFileCheckIcon] = useState("");
    const [userName, setUserName] = useState("");

    const [alertText, setAlertText] = useState("");
    const [showAlert, setShowAlert] = useState(false);
    const [operationOngoing, setOperationOngoing] = useState(false);
    
    const DUE_DATE_MAX_IN_MS  = (process.env.REACT_APP_DEADLINEDATE_MAX_VALUE*1000*60*60*24) 
    const REMINDER_DATE_DEFAULT_VALUE_IN_MS = (process.env.REACT_APP_REMINDDATE_BEFORE_DUEDATE*1000*60*60*24)
    const REMINDER_DATE_DEFAULT_VALUE_CALC_IN_MS = DUE_DATE_MAX_IN_MS - REMINDER_DATE_DEFAULT_VALUE_IN_MS

    const ICON_FILE_VALIDATING = "SPINNER";
    const ICON_FILE_VALID = "./assets/icons/check2.svg";
    const ICON_FILE_INVALID = "./assets/icons/exclamation.svg";
    const ICON_FILE_VALID_STATIC = "./assets/icons/check2-circle.svg";
    const ICON_FILE_INVALID_STATIC = "./assets/icons/exclamation-circle.svg";

    const DOC_MASTER = "MASTER";
    const DOC_ATTACHMENT = "ATTACHMENT";

    const parentEventSend = props.parentEventCb;
 
    const sensors = [useSensor(PointerSensor)];
    
    const deleteAll = event => {
        setSignersCategory([{id:signersCategoryIndex+1, signers:[], forceOrder:false}]);
        setSignersCategoryIndex(signersCategoryIndex+1);
        setFileValidState("IDLE");
        setFileCheckIcon("");
        deleteDocumentReference("*");
        setdocReferences([]);
        setShowAlert(false);
        };

    const handleDocReferenceDelete = item => {
        var filteredList = docReferences.filter(i => i.docId !== item.docId);
        setdocReferences(filteredList);
        deleteDocumentReference(item.docId);
    };

    function showAlertMessage(alertText) {
        setAlertText(alertText);
        setShowAlert(true);
    }                 

    function defaultdueDate() {

        var date  = new Date(new Date().getTime()+DUE_DATE_MAX_IN_MS);
        var dateString = date.toISOString().split('T')[0];
        setDuedate(dateString);
    }

    function defaultRemindDate() {

        var date  = new Date(new Date().getTime()+REMINDER_DATE_DEFAULT_VALUE_CALC_IN_MS);
        var dateString = date.toISOString().split('T')[0];
        setReminder(dateString);
    }

    function checkdueDate(newDate) {
        var newDueDate = new Date(newDate);
        var todayDate = new Date();

        if(newDate === "") {
            return;
        }

        var newReminderDate = new Date(newDueDate.getTime() - REMINDER_DATE_DEFAULT_VALUE_IN_MS);
        // update remider date
        if(todayDate > newReminderDate) {
            newReminderDate = todayDate;
        }
        var dateString = newReminderDate.toISOString().split('T')[0];
        setReminder(dateString);
        document.getElementById("reminder").value = dateString; // ei näemmä päivity näyttöön ilman tätä
    }

    function todayString() {
        var dateString = new Date().toISOString().split('T')[0];
        return dateString;
    }

    function changeHandler(event){

        switch(event.target.name) {
            case "docName":
                setDocName(event.target.value);
                break;
            case "signfile":
                dismissAlert();
                validateSignDoc(event.target.files[0]);
                break;
            case "subject":
                setSubject(event.target.value);
                break;
            case "message":
                setMessage(event.target.value);
                break;
            case "duedate":
                checkdueDate(event.target.value);
                setDuedate(event.target.value);
                setMessagePlaceholder(createMessagePlaceholder(userName, event.target.value));
                break;
            case "reminder":
                setReminder(event.target.value);
                break;
            default: 
        }
    }

    function getSignersCount() {
        var signersCount = 0;
        signersCategory.map(item =>  signersCount =  signersCount + item.signers.length);
        return signersCount;
    }

    function submitHandler(event) {

        event.preventDefault();
        if(fileValidState === 'INVALID') {
            showAlertMessage("The selected file is not valid");
            return;
        } else if(fileValidState === 'VALIDATING') {
            showAlertMessage("File validation ongoing. Please wait.");
            return;
        }
        if(getSignersCount() < 1) {
            showAlertMessage("Email signers list is empty");
            return;
        }
        if(docReferences.find(item => item.type === DOC_MASTER) === undefined) {
            // master doc missing
            showAlertMessage("The selected file is not valid");
            return 
        }
        setOperationOngoing(true);

        const data = new FormData();

        data.append('documentName', docName);
        data.append("docReferences", JSON.stringify(docReferences.map((item, index) => {
            item.orderNum = index;
            return item;
            })));
        data.append('signersCategories', JSON.stringify(signersCategory));

        data.append('subject', subject);
        data.append('message', message);
        data.append('duedate', duedate); 
        data.append('reminderdate', reminder);

        axios.post(constants.SERVER_URL+'/api/saveSignReq', data, {headers: {'content-type': 'multipart/form-data'}})
        .then(resp =>{
            setOperationOngoing(false);
            parentEventSend("UPDATE_MENU");
            setRedirectPath(constants.SERVER_CONTEXT_PATH+'/pending');
            document.getElementById("nav-item-pending").click();
        })
        .catch(err => {
            setOperationOngoing(false);
            if(!checkAxiosRespSession(err)) {
                console.log("saveSignReq error", err);
                showAlertMessage("Sign request not created.");
            }
        })
    } 

    function deleteDocumentReference(docId) {
        axios.post(constants.SERVER_URL+'/api/deletedraftdocument', {docId:docId})
            .then(resp =>{
                console.log("Document reference deleted: ", docId);
            })
            .catch(err => {
                console.log("Document deletion failed: ", docId);   
            })
    }

    function validateSignDoc(file) {
        if(file) {
            setFileCheckIcon(ICON_FILE_VALIDATING);
            setFileValidState("VALIDATING");
            setOperationOngoing(true);
            const data = new FormData();

            data.append('file', file);
    
            axios.post(constants.SERVER_URL+'/api/createdraftdocument', data, {headers: {'content-type': 'multipart/form-data'}})
            .then(resp =>{
                   //valid
                   console.log("FILE VALIDATION OK: ", resp.data.docId);
                   console.log("docReferences", docReferences);
                   if(docReferences.length === 0) { // first added doc is master
                        docReferences.push({docName:file.name, docId:resp.data.docId, type: DOC_MASTER});
                   } else { // and rest of the documents are attachments
                        var master = docReferences.find(item => item.type === DOC_MASTER);
                        if(master === undefined) { // master not set -> set it now
                            docReferences.unshift({docName:file.name, docId:resp.data.docId, type: DOC_MASTER});
                        } else {
                            docReferences.push({docName:file.name, docId:resp.data.docId, type: DOC_ATTACHMENT});
                        }
                   }
                   setdocReferences(docReferences);
                   setFileValidState("VALID");
                   setOperationOngoing(false);
                   setFileCheckIcon(ICON_FILE_VALID);
                   setTimeout(() => setFileCheckIcon(ICON_FILE_VALID_STATIC), 1000);
            })
            .catch(err => {
                if(!checkAxiosRespSession(err)) {
                    console.log("FILE VALIDATION ERROR:",err);
                    console.log("FILE VALIDATION ERROR:",err.response);
                    if(err.response.status === 403) {
                        // Amount of draft files exceeded
                        showAlertMessage("No more PDF-documents allowed");
                        setFileCheckIcon("");
                        setFileValidState("IDLE");
                    } else {
                    // selected file not valid
                    showAlertMessage("The selected file is not valid");
                    //setFileValidState("VALID");
                    setFileValidState("INVALID");
                    setFileCheckIcon(ICON_FILE_INVALID);
                    setTimeout(() => setFileCheckIcon(ICON_FILE_INVALID_STATIC), 3000);
                    }

                }
                setOperationOngoing(false);
            })
        } else {
            // clear icon
            setFileCheckIcon("");
        }
    }

    const getDocument = (id) => {
        return constants.GET_FILE_URL+"/api/getdocbyid/"+id;
    }

    function dismissAlert() {
        setShowAlert(false);
    }

    function AlertError() {
        if (showAlert) {
            window.scrollTo(0,0);
            return (
                <div>
                <Alert variant="danger" onClose={dismissAlert} dismissible>
                <h4>{t("Sign request error")}</h4>
                <p>
                    {t(alertText)}
                </p>
                </Alert>
                </div>
            );
        }
    }

    const checkFetchRespSession = (resp)=> {
        if (!resp.ok) {
          if(resp.status === 401) {
            parentEventSend("SESSION_EXPIRED");
          }
          throw Error(resp.statusText); 
        }
        return resp; 
      }

      const checkAxiosRespSession = (err)=> {
          if(err.response && err.response.status === 401) {
            parentEventSend("SESSION_EXPIRED");
            return true;
        }
        return false;
      }      
      
    const documentListItems = (type) => docReferences.map((item, index) => {


        if(item.type === type && item.type=== DOC_MASTER) {
            return ( // master
                <div className="tag-item-master" key={index}>
                <a href = {getDocument(item.docId)} download={item.docName} target="_blank" rel="noopener noreferrer">{item.docName}</a> 
                    <button
                    type="button"
                    className="button" 
                    onClick={() => handleDocReferenceDelete(item)}
                    >
                    &times; 
                    </button>
                </div>
            )

        } else if(item.type === type && item.type=== DOC_ATTACHMENT) { // attachment
            return (
                <Attachment item = {item} getDocument = {getDocument} handleDocReferenceDelete = {handleDocReferenceDelete} key={item.docId}></Attachment>
            )
        } else {
            return null;
        }
    }) 

    const createMessagePlaceholder = (userNameArg, dueDate) => {
        var todayDateString = new Date().toLocaleDateString('fi');
        var dueDateString = new Date(dueDate).toLocaleDateString('fi');
        var defaultTextFin =    "Olet vastaanottanut uuden allekirjoituspyynnön dokumentille.\n" +
                                "Pyynnön lähetti "+ todayDateString + " Teemu Testaaja. " +
                                "Allekirjoituksen eräpäivä on "+ dueDateString +".\n" + 
                                "Voit tarkastella dokumenttia ja allekirjoittaa sen eSignature-palvelussa.\n" + 
                                "Seuraa linkkiä: " + process.env.REACT_APP_ESIGN_URL + "\n\n";
        var defaultTextSve =    "Du har mottagit en begäran att signera ett nytt dokument.\n" + 
                                "Begäran är utskickad "+ todayDateString +" av Teemu Testaaja. " +
                                "Förfallodatum är " + dueDateString +".\n" +
                                "Du kan kontrollera och signera dokumentet i signeringstjänsten.\n" + 
                                "Vänligen, följ linken: " + process.env.REACT_APP_ESIGN_URL + "\n\n";
        var defaultTextEnu =    "You have received signature request for new document.\n" + 
                                "The request was sent " + todayDateString +" by Teemu Testaaja. " +
                                "Duedate for the request is "+ dueDateString +".\n" + 
                                "You can review and sign the document at eSignature Service.\n" +
                                "Please follow the link: " + process.env.REACT_APP_ESIGN_URL + "\n\n";
        var defaultText =   defaultTextFin.replace("Teemu Testaaja", userNameArg) +
        defaultTextSve.replace("Teemu Testaaja", userNameArg) +
        defaultTextEnu.replace("Teemu Testaaja", userNameArg);
        return defaultText;
    }

    useEffect(() => {
        if(messagePlaceholder === "") {
            fetch(constants.SERVER_URL + "/api/profile",{method:'get'})
            .then(resp => checkFetchRespSession(resp))
            .then(resp => resp.json())
            .then(data => {
                setUserName(data.firstname + " " + data.lastname)
                setMessagePlaceholder(createMessagePlaceholder(data.firstname + " " + data.lastname, duedate))
            })
            .catch(error => console.log("Fetching profile error:", error));
            defaultdueDate();
            defaultRemindDate();
            deleteDocumentReference("*");
        }
      });

    const showProgressbar = () => {
        if(operationOngoing === true) {
            return (<ProgressBar animated now={100} label={t("Operation ongoing")}/>);
        } else {
            return null;
        }
    }

    function handleDragEndAttachment(event) {
        const {active, over} = event;
        
        if(active === null || over === null) {
            return;
        }

        if (active.id!== over.id) {
          setdocReferences((docReferences) => {
            var oldIndex = 0;
            docReferences.map((item, index) => { 
                if(item.docId === active.id) {
                    oldIndex = index;
                }
                return item;
                });
            var newIndex = 0
            docReferences.map((item, index) => {
                if(item.docId === over.id) {
                    newIndex = index;
                }
                return item;
            });
            return arrayMove(docReferences, oldIndex, newIndex)
          });
        }
      }

    function signersChanged(categoryId, signers) {
        var updatedCategory = signersCategory.map(item => {
            if(item.id === categoryId) {
                item.signers = signers;
            }
            return item;
        })
        setSignersCategory(updatedCategory);        
    }

    function forceSignOrderChanged(categoryId, forceValue) {

        var updatedCategory = signersCategory.map(item => {
            if(item.id === categoryId) {
                item.forceOrder = forceValue;
            }
            return item;
        })
        setSignersCategory(updatedCategory);
    }

    function dueDateChanged(categoryId, dueDate) {

        var updatedCategory = signersCategory.map(item => {
            if(item.id === categoryId) {
                item.dueDate = dueDate;
            }
            return item;
        })
        setSignersCategory(updatedCategory);
    }

    function reminderDateChanged(categoryId, reminderDate) {

        var updatedCategory = signersCategory.map(item => {
            if(item.id === categoryId) {
                item.reminderDate = reminderDate;
            }
            return item;
        })
        setSignersCategory(updatedCategory);
    }

    function addSignerCategory(categoryId) {
        var index = signersCategory.findIndex(item => item.id === categoryId);

        var newCategoryArray = [...signersCategory];
        newCategoryArray.splice(index+1, 0, {id:signersCategoryIndex+1,signers:[], forceOrder:false, dueDate:"", reminderDate:""});
        setSignersCategory(newCategoryArray);
        setSignersCategoryIndex(signersCategoryIndex+1);
    }

    function handleDeleteCategory(id) {
        setSignersCategory(signersCategory.filter(item => item.id !== id));
    }

    function getSignersCategories() {
        return [...signersCategory];
    }

    function getDueDateMax() {
        console.log("getDueDateMax called", duedate)
        return duedate;
    }


    const doRender = () => {
        if(redirectPath) {
            return <Redirect to= {redirectPath} />
        } else {
            return(
                <div>
                    <Customize.Style />
                    <p><br></br> </p>
                    {AlertError()}
                    <h1>{t("Create new signature request")}</h1>
                    <Form onSubmit={submitHandler}>
                        <br />
                        <div className="row">
                        <div className="col-md-8">
            
                        <label htmlFor="docName">{t("Document Name")}:</label><br />
                        <FormControl type="text" id="docName" name="docName" maxLength={32} placeholder={t("Name of the Document")} required onChange={changeHandler}/><br />
            
            
                        <label htmlFor="signfile">{t("Select PDF-document to sign")}</label><br/>
                        {documentListItems(DOC_MASTER)}
                        <br/>{t("Attachments")}<br/>
                        <DndContext
                           sensors = {sensors}
                           collisionDetection={closestCenter}
                           onDragEnd = {handleDragEndAttachment}
                        >
                        <SortableContext
                           items = { docReferences.map((item) => item.docId) }
                           strategy={horizontalListSortingStrategy}
                        >                        
                           {documentListItems(DOC_ATTACHMENT)}
                        </SortableContext>
                        </DndContext>                        

                        <div className="row"> 
                            <div className="col-lg-5 col-md-10 col-sx-10">
                                <FormControl type="file" id="signfile" name="signfile" accept=".pdf" required onChange={changeHandler}/>
                            </div>
                            <div className="col-lg-7 col-md-2 col-sx-2" sm={4}>
                            {fileCheckIcon?fileCheckIcon ==="SPINNER"?<Spinner animation="border" />:<img src={fileCheckIcon} alt="" height="35" width="35"></img>:null}
                            </div> 
                        </div> 
                        <br /><br />
                        <label htmlFor="signers">{t("List of signers email addresses")}</label><br/>
                        

                        {
                        signersCategory.map((item, index) => (
                            <SignersCategory 
                            id = {item.id}
                            key = {item.id}
                            index = {index} 
                            signersChangedCB = {signersChanged}
                            handleDeleteCategory = {handleDeleteCategory}
                            addSignerCategoryCB = {addSignerCategory}
                            dueDateChangedCB = {dueDateChanged}
                            reminderDateChangedCB = {reminderDateChanged}
                            forceSignOrderChangedCB = {forceSignOrderChanged}
                            disableDelete = {index === 0?true:false}
                            disableDates = {index < signersCategory.length-1?false:true}
                            getSignersCategoriesCB = {getSignersCategories}
                            getDueDateMaxCB = {getDueDateMax}
                            />)
                        )}    
                        <div className="row">
                            <div className="col-md-3">
                                <label htmlFor="duedate">{t("Due date for signature")}</label><br/>
                                <FormControl type="date" id="duedate" name="duedate" defaultValue ={duedate} min = {todayString()} onChange={changeHandler}/>
                            </div>
                            <div className="col-md-3">
                                <label htmlFor="reminder">{t("Reminder")}</label><br />
                                <FormControl type="date" id="reminder" name="reminder" defaultValue ={reminder} min = {todayString()} max={duedate} onChange={changeHandler}/>
                            </div>
                        </div>

                        <fieldset>

                        <legend>{t("Request message")}</legend>
                        <label htmlFor="subject">{t("Subject")}</label><br />
                        <FormControl type="text" id="subject" name="subject" maxLength={78} placeholder={t("Request for eSignature")} required onChange={changeHandler}/><br />
                        <FormGroup controlId="formControlsTextarea">
                        <FormLabel>{t("Message")}</FormLabel>
                        <FormControl as="textarea" placeholder={
                                                                            t("Here you can add your own message to the recipients of the signature request") + "\n\n" +
                                                                            t("Below you can see the standard part of the message which will be attached to your message")
                                                                            } rows="5" name="message" onChange={changeHandler}/>
                        <FormControl as="textarea" placeholder={messagePlaceholder} rows="7" disabled={true}/>
                        </FormGroup>
                        </fieldset> <br />
                            </div>
                            <div className="col-md-4"/>
                            </div>

                        <div className="col-md-8">
                        <br /> 
                        {showProgressbar()}
                        <br /> 
                        <Button type="submit" disabled={operationOngoing}>{t("Send request")}</Button> <Button type="reset" disabled={operationOngoing} onClick={deleteAll}>{t("Cancel request")}</Button>
                        <br /> </div>
            
                        <br />        
                        <br />
            
                    </Form> 
                    <p></p>
                    <p></p>
                    <p></p>
                    <br />        
                    <br />
                </div> 
            );
        }
    }    
    return doRender();

}

export default (RequestSignature);
